module.exports = __webpack_public_path__ + "img/payment-alipay.0a200e85.png";